import type { PluginContainerData } from './../../ricos-schema/next-schema/index.js';
import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
} from './../../ricos-schema/next-schema/index.js';

export const ORIGINAL_SHAPE_WIDTH = 200;
export const DEFAULT_COLOR = '#000000';
export const SEARCH_DEBOUNCE_MS = 350;

export const DEFAULTS = {
  config: {
    alignment: 'center',
    size: 'CONTENT',
    textWrap: true,
  },
} as const;

export type DataColorMap = Record<string, { color: string; opacity: string }>;

export const RICOS_DEFAULTS: {
  containerData: PluginContainerData;
} = {
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.ORIGINAL,
    },
    textWrap: true,
  },
} as const;

export const SHAPE_COLORS_MODAL_ID = `${Node_Type.SHAPE}.colors`;
export const SHAPE_SIZE_MODAL_ID = `${Node_Type.SHAPE}.size`;
export const SHAPE_ALIGNMENT_MODAL_ID = `${Node_Type.SHAPE}.alignment`;
export const SHAPE_COLOR_PICKER_MODAL_ID = `${Node_Type.SHAPE}.colorPicker`;

export const ALLOWED_SHAPE_ATTRIBUTES = [
  'data-bbox',
  'viewBox',
  'xmlns',
  'd',
  'fill',
  'opacity',
] as const;

export const VECTOR_ART_CATEGORY_ID = 'b8774c7d-152e-4fca-b0bd-69601605d49c' as const;
export const SHAPES_CATEGORY_ID = '95ffa6e1-99d0-48a4-a3b8-a935fe630596' as const;

export const SHAPE_SEARCH_ITEMS_BASE_URL =
  'https://apps.wix.com/_api/ricos-media-proxy/public-media/search-items';
